var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.percentage > 0)?_c('v-chip',{attrs:{"dark":"","color":_vm.color}},[_vm._v("+"+_vm._s(_vm.percentage.toFixed(0))+"%")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }